<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 section" id="dedication">
<h1>Dedication</h1>
<p style="text-align:center;">I dedicate <em>The Shrinking</em> to all the children who enjoyed the spoken version.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?fb55f424